module.exports = __webpack_public_path__ + "available shift job.svg?6f8a8287e542b8c7aefefafe54caf7f1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/available shift job.svg
// module id = 355
// module chunks = 0